import { temConsentimento } from "@/lib/consentimento"

/**
 * Preferências leves do usuário (tema, densidade etc.), gravadas em
 * localStorage e espelhadas em cookie. Toda escrita é condicionada ao
 * consentimento da categoria `preferencias` — sem ele, nada é persistido.
 */

const PREFIXO = "sigi.pref."
const UM_ANO = 60 * 60 * 24 * 365

export function lerPreferencia(chave: string): string | null {
  try {
    return localStorage.getItem(PREFIXO + chave)
  } catch {
    return null
  }
}

export function salvarPreferencia(chave: string, valor: string): void {
  if (!temConsentimento("preferencias")) return
  try {
    localStorage.setItem(PREFIXO + chave, valor)
    document.cookie = `${PREFIXO}${chave}=${encodeURIComponent(valor)}; path=/; max-age=${UM_ANO}; SameSite=Lax`
  } catch {
    /* armazenamento indisponível — degradação silenciosa */
  }
}

/** Remove todas as preferências persistidas (ex.: revogação do consentimento). */
export function limparPreferencias(): void {
  const chaves: string[] = []
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const chave = localStorage.key(i)
      if (chave?.startsWith(PREFIXO)) chaves.push(chave)
    }
    chaves.forEach((chave) => localStorage.removeItem(chave))
  } catch {
    /* ignora */
  }
  for (const chave of ["tema"]) {
    document.cookie = `${PREFIXO}${chave}=; path=/; max-age=0; SameSite=Lax`
  }
}
